import React from 'react';
import PropTypes from 'prop-types';
import { Stepper as MuiStepper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { capitalize } from '@mui/material/utils';
import StepConnector from './StepConnector';

const useStyles = makeStyles()((theme) => ({
  root: {
    '&.backgroundDefault': {
      backgroundColor: theme.palette.custom.gray.extraLight,
    },
    '&.backgroundTransparent': {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 1),
    },
  },
}));

const defaultConnector = <StepConnector />;

function Stepper({ className, connector = defaultConnector, background = 'default', ...props }) {
  const { classes, cx } = useStyles(props, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    props,
  });
  return (
    <MuiStepper
      {...props}
      className={cx(`background${capitalize(background)}`, className)}
      classes={classes}
      connector={connector}
    />
  );
}

Stepper.muiName = 'Stepper';

Stepper.propTypes = {
  className: PropTypes.string,
  connector: PropTypes.element,
  background: PropTypes.oneOf(['default', 'transparent']),
};

export default Stepper;
